import MarkerView from './MarkerView';


export default class SelectableMarkerView extends MarkerView {
  get mapEvents() {
    return {
      'click': 'markerClicked'
    };
  }

  initialize(options) {
    super.initialize(options);
    this.listenTo(this.model, 'selected', this.openDetail);
    this.listenTo(this.model, 'deselected', this.closeDetail);
  }

  markerClicked() {
    this.model.addToNewSelection();
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/views/geo/SelectableMarkerView.js
 **/